
import type { ReactNode } from 'react';
import {forwardRef } from 'react';

interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ children, className = '', id }, ref) => {
    return (
      <section ref={ref} id={id} className={`relative ${className}`}>
        {children}
      </section>
    );
  }
);

Section.displayName = 'Section';

export default Section;
